import Vue from 'vue'
import Vuetify from 'vuetify'

import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuetify, { iconfont: 'mdi' })

export default new Vuetify({
  theme: {
    themes: {
      light: {
        // primary: '#031690',
        primary: '#F48021',
        secondary: '#3C3C3C',
        accent: '#FFC300',
        error: '#D62C07',
        info: '#2196f3',
        success: '#4EB000'
      }
    }
  }
})
